{
  "customer-form": {
    "field": {
      "available_points": "Điểm hiện tại",
      "birthday": "Ngày sinh",
      "black_listed": "Danh sách đen",
      "black_listed_hint": "Khách hàng trong danh sách đen không thể đặt lịch hẹn trực tuyến nữa",
      "communication_way": "Phương thức liên lạc",
      "email": "Email",
      "phone_nr": "Số điện thoại",
      "name": "Tên",
      "new_point_balance": "Số điểm mới",
      "note": "Ghi chú",
      "notification_subscribed": "Thông báo khuyến mãi",
      "surname": "Họ",
      "update_point_balance": "Thêm bớt (+/-) điểm"
    },
    "text": {
      "off": "TẮT",
      "on": "BẬT"
    }
  }
}
